export const convertSCPToLegacyKnowledgeBase = scpKnowledgeBase => ({
  isConvertedSCPKnowledgeBase: true,
  absoluteUrl: scpKnowledgeBase.values.hs_absolute_url,
  additionalLanguages: scpKnowledgeBase.translations ? Object.keys(scpKnowledgeBase.translations).filter(language => language !== scpKnowledgeBase.values.hs_language) : [],
  translations: scpKnowledgeBase.translations,
  articleTemplatePath: '',
  domain: scpKnowledgeBase.values.hs_domain,
  id: scpKnowledgeBase.values.hs_id,
  includePrimaryLanguageInSlug: scpKnowledgeBase.values.hs_absolute_url && scpKnowledgeBase.values.hs_absolute_url.includes(scpKnowledgeBase.values.hs_language) || false,
  indexTemplatePath: '',
  isKnowledgeBasePrivate: false,
  language: scpKnowledgeBase.values.hs_language,
  name: scpKnowledgeBase.values.hs_name,
  resolvedDomain: scpKnowledgeBase.values.hs_domain,
  slug: scpKnowledgeBase.values.hs_slug,
  subcategoryTemplatePath: '',
  headerCompanyLogo: {
    aspectRatio: 1,
    height: 0,
    linkToUrl: '',
    src: ''
  },
  scpValues: scpKnowledgeBase.values,
  translatedContent: {}
});
export const convertLegacyKBRequestToSCP = legacyKBSetupRequest => ({
  knowledgeBase: {
    values: {
      hs_domain: legacyKBSetupRequest.knowledgeBase.domain,
      hs_slug: legacyKBSetupRequest.knowledgeBase.includePrimaryLanguageInSlug ? `${legacyKBSetupRequest.knowledgeBase.language}/${legacyKBSetupRequest.knowledgeBase.slug}` : legacyKBSetupRequest.knowledgeBase.slug,
      hs_name: legacyKBSetupRequest.knowledgeBase.name,
      hs_language: legacyKBSetupRequest.knowledgeBase.language
    }
  },
  themeSettingsValues: {
    group_layout: {
      layout_type: legacyKBSetupRequest.themeSettingsValues.values.theme_type
    }
  },
  categories: legacyKBSetupRequest.categories
});
export const getKnowledgeBaseEmptyState = () => ({
  absoluteUrl: '',
  additionalLanguages: [],
  articleTemplatePath: '',
  domain: '',
  id: 0,
  includePrimaryLanguageInSlug: false,
  indexTemplatePath: '',
  isKnowledgeBasePrivate: false,
  language: '',
  name: '',
  resolvedDomain: '',
  slug: '',
  subcategoryTemplatePath: '',
  translatedContent: {},
  headerCompanyLogo: {
    aspectRatio: 1,
    height: 0,
    linkToUrl: '',
    src: ''
  },
  scpValues: undefined,
  isConvertedSCPKnowledgeBase: false,
  translations: {}
});